import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Check, UserRound } from "lucide-react";
import { editRequestKnowledge } from "../../actions/requestKnowledge";
import { DateParser } from "../utils/Utils";
import ImageProfil from "../Profil/ImageProfil";

const AsignKnowledge = ({ request, closeModal }) => {
  const [referent, setReferent] = useState("");
  const [saving, setSaving] = useState(false);
  const usersData = useSelector((state) => state.usersReducer);
  const dispatch = useDispatch();

  const referentUsers = Object.values(usersData).filter(
    (user) => user.isReferent || user.isAdmin
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!referent) return;
    setSaving(true);
    try {
      await dispatch(editRequestKnowledge(request.id, "1", referent));
      closeModal();
      Swal.fire({
        icon: "success",
        title: "Tutoriel assigné",
        text: "La demande a été assignée au référent.",
      });
    } catch (error) {
      setSaving(false);
      Swal.fire({
        icon: "error",
        title: "Échec de l'assignation",
        text: "L'assignation n'a pas pu être enregistrée, réessayez.",
      });
    }
  };

  return (
    <form className="assign-modal" onSubmit={handleSubmit}>
      <div className="assign-scroll">
      {/* Résumé de la demande */}
      <div className="assign-summary">
        <div className="assign-requester">
          <span className="assign-avatar">
            <ImageProfil id={request?.user?.id} />
          </span>
          <div className="assign-requester-meta">
            <span className="assign-requester-name">
              {request?.user?.firstname} {request?.user?.name}
            </span>
            <span className="assign-requester-date">
              {DateParser(request?.createdAt)}
            </span>
          </div>
        </div>
        <div className="assign-tags">
          <span className="req-chip">{request?.nature}</span>
          <span className="assign-chip-cat">{request?.categorie}</span>
        </div>
      </div>

      <div className="assign-demande">
        <span>Demande</span>
        <p>{request?.texte}</p>
      </div>

      {/* Choix du référent */}
      <div className="assign-section">
        <span className="assign-label">Assigner à un référent</span>
        {referentUsers.length === 0 ? (
          <p className="assign-empty">Aucun référent disponible.</p>
        ) : (
          <div className="assign-referents">
            {referentUsers.map((user) => (
              <button
                type="button"
                key={user.id}
                className={`assign-ref ${
                  String(referent) === String(user.id) ? "selected" : ""
                }`}
                onClick={() => setReferent(user.id)}
              >
                <span className="assign-ref-avatar">
                  <ImageProfil id={user.id} />
                  <UserRound size={16} className="assign-ref-fallback" />
                </span>
                <span className="assign-ref-name">
                  {user.firstname} {user.name}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
      </div>

      {/* Actions */}
      <div className="assign-footer">
        <button
          type="button"
          className="ds-btn ds-btn--ghost"
          onClick={closeModal}
        >
          Annuler
        </button>
        <button
          type="submit"
          className="ds-btn ds-btn--primary"
          disabled={!referent || saving}
        >
          <Check size={15} />
          {saving ? "Assignation…" : "Assigner le tutoriel"}
        </button>
      </div>
    </form>
  );
};

export default AsignKnowledge;
